<div class="tag">
  <span>{{option?.label}}</span>
  <a href="" (click)="remove($event, option)" class="icon-remove tag-icon ml-3"
     [inlineSVG]="'/assets/svg/close.svg'"></a>
</div>
